module.exports = __webpack_public_path__ + "media/images/article2/stat2-1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/article2/stat2-1.svg
// module id = 73
// module chunks = 0